import { useState } from 'react';
import VerificationInputRVI from 'react-verification-input';

interface IVerificationInputProps {
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
}

export const VerificationInput = ({ onChange, onComplete }: IVerificationInputProps) => {
  const [inputValue, setInputValue] = useState<string>('');

  const handleOnChange = (value: string) => {
    setInputValue(value);
    onChange(value);
  };

  return (
    <VerificationInputRVI
      length={5}
      validChars="0-9"
      autoFocus
      placeholder=""
      classNames={{
        container: 'code-container',
        character: 'code-character',
        characterInactive: 'character--inactive',
        characterSelected: 'code-character--selected',
      }}
      onChange={handleOnChange}
      onComplete={onComplete}
      value={inputValue}
      inputProps={{ 'data-cy': 'input-pin', 'data-testid': 'verification-input' }}
    />
  );
};
